export default "__VITE_ASSET__Dch8qur8__"